import React, { FC } from 'react';
import './LabelledNumber.css';

interface Props {
  label: string;
}

const LabelledInvalid: FC<Props> = ({ label }) => (
  <div className="labelled-number">
    <div className="number">
      <div className="main-number">-</div>
    </div>
    <div className="number-label">{label}</div>
  </div>
);

export default LabelledInvalid;
